import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseViewComponent, EditableCardState } from '@sb/library/base';

@Component({
    selector: 'lib-editable-card',
    templateUrl: './editable-card.component.html',
    styleUrls: ['./editable-card.component.scss']
})
export class EditableCardComponent extends BaseViewComponent {

    @Input() hasCardContainer: boolean = true;
    @Input() state: EditableCardState = EditableCardState.View;
    @Input() qaTag: string = "";

    @Output() editButtonClicked = new EventEmitter();
    @Output() cancelButtonClicked = new EventEmitter();
    @Output() saveButtonClicked = new EventEmitter();

    EditClicked(): void {
        this.editButtonClicked.emit(true);
    }

    CancelClicked(): void {
        this.cancelButtonClicked.emit(true);
    }

    SaveClicked(): void {
        this.saveButtonClicked.emit(true);
    }

    get EditableCardState(): typeof EditableCardState {
        return EditableCardState;
    }
}
